// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.url_provider.`data`.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import one.healthium.url_provider.`data`.dto.UrlItemDto

@OptIn(InternalKtorfitApi::class)
internal class _UrlProviderApiClientImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : UrlProviderApiClient {
  override suspend fun getLegalUrls(locale: String): List<UrlItemDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/legal_product.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<List<UrlItemDto>>(),)!! 
  }
}

internal class _UrlProviderApiClientProvider : ClassProvider<UrlProviderApiClient> {
  override fun create(_ktorfit: Ktorfit): UrlProviderApiClient = _UrlProviderApiClientImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

internal fun Ktorfit.createUrlProviderApiClient(): UrlProviderApiClient = _UrlProviderApiClientImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
